import { useState, useEffect } from "react";

export default function useLoadStatus(statusId, darkTheme) {
  const [loadStatuses, setLoadStatuses] = useState([]);
  const [currentStatus, setCurrentStatus] = useState({});
  const [currentStatusIndex, setCurrentStatusIndex] = useState(0);
  const [nextStatus, setNextStatus] = useState({});

  const allStatuses = [
    {
      id: "ONHOLD",
      name: "On Hold",
      shortName: "OH",
      disableUpdates: true,
      backgroundColor: darkTheme ? "magenta.60" : "magenta.30"
    },
    {
      id: "A-RTGDE",
      name: "Routing Guide",
      shortName: "AR",
      backgroundColor: darkTheme ? "warning.60" : "warning.30"
    },
    {
      id: "AVA",
      name: "Available",
      shortName: "AV",
      backgroundColor: darkTheme ? "teal.60" : "teal.30"
    },
    {
      id: "COV",
      name: "Covered",
      shortName: "CO",
      backgroundColor: darkTheme ? "gold.60" : "gold.30"
    },
    {
      id: "COVCOM",
      name: "Covered",
      shortName: "CO",
      backgroundColor: darkTheme ? "gold.60" : "gold.30"
    },
    {
      id: "DIS",
      name: "Dispatched",
      shortName: "DS",
      backgroundColor: darkTheme ? "primary.60" : "primary.30"
    },
    {
      id: "LOA",
      name: "Loading",
      shortName: "LG",
      backgroundColor: darkTheme ? "orange.60" : "orange.30"
    },
    {
      id: "LOAD",
      name: "In Transit",
      shortName: "LD",
      backgroundColor: darkTheme ? "success.60" : "success.30"
    },
    {
      id: "DEL",
      name: "Delivering",
      shortName: "DG",
      backgroundColor: darkTheme ? "purple.60" : "purple.30"
    },
    {
      id: "DELV",
      name: "Delivered",
      shortName: "DD",
      backgroundColor: darkTheme ? "cherry.60" : "cherry.30"
    },
  ];

  useEffect(() => {
    setLoadStatuses(allStatuses);
  }, []);

  useEffect(() => {
    const index = loadStatuses.findIndex(status => status.id === statusId);
    setCurrentStatus(loadStatuses[index]);
    setCurrentStatusIndex(index);
    setNextStatus(loadStatuses[index + 1]);
  }, [statusId, loadStatuses]);

  return { loadStatuses, currentStatus, currentStatusIndex, nextStatus };
}